import React from "react";
import "./styles.scss";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { CircularProgressWithLabel } from "../ProgressBar";
import { Paper } from "@mui/material";

const FileUpload = ({
  acceptFileType = "image/*",
  handleChange,
  label,
  bgImageSrc,
  upProgress,
  ...otherProps
}) => {
  const isUploading = upProgress !== 100 && upProgress !== 0;
  return (
    <label
      className={
        isUploading ? "custom-file-upload uploading" : "custom-file-upload"
      }
    >
      {!isUploading && (
        <input type="file" onChange={handleChange} accept={acceptFileType} />
      )}
      <Paper
        style={{
          backgroundImage: `url(${bgImageSrc})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "100%",
          width: "100%",
        }}
      >
        {isUploading && <CircularProgressWithLabel value={upProgress} />}
        {!isUploading && (
          <AddCircleOutlineIcon className="add-icon placeholder" />
        )}
      </Paper>
    </label>
    // </div>
  );
};

export default FileUpload;
